import { useState, useEffect } from "react";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";

const alignmentData = [
  { title: "Our Vision", desc: "To become Tanzania's leading hospitality and travel services provider, offering exceptional accommodation experiences, authentic local hospitality, and innovative tourism solutions.", img: banner1 },
  { title: "Our Mission", desc: "To provide high-quality, comfortable, and professionally managed accommodation and travel services that exceed guest expectations through personalized care and operational excellence.", img: banner2 },
  { title: "Our Goal", desc: "To build a trusted and sustainable hospitality brand through quality service, diversified accommodation, travel support, and long-term value for shareholders and stakeholders.", img: banner3 }
];

export default function HomeBanner3() {
  const [active, setActive] = useState(0);

  const next = () => setActive((p) => (p + 1) % alignmentData.length);
  const prev = () => setActive((p) => (p - 1 + alignmentData.length) % alignmentData.length);

  useEffect(() => {
    const t = setInterval(next, 7000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;400;500;600;700;800&display=swap');
        :root { --sunflower-amber: #BC9132; --text-navy: #012243; --text-slate: #475569; --bg-light: #F8FAFC; --border-subtle: #E2E8F0; --font-corporate: 'Libre Franklin', sans-serif; }
        .alignment-viewport { position: relative; min-height: 80vh; display: flex; align-items: center; font-family: var(--font-corporate); background: var(--text-navy); overflow: hidden; }
        .alignment-bg { position: absolute; inset: 0; background-size: cover; background-position: center; transition: all 1s ease; opacity: 0.25; filter: blur(2px); }
        .alignment-container { position: relative; z-index: 2; max-width: 1280px; margin: 0 auto; padding: 80px 24px; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; width: 100%; }
        .alignment-content h2 { color: #fff; font-size: clamp(2rem, 4vw, 3.2rem); font-weight: 800; margin-bottom: 24px; letter-spacing: -0.02em; line-height: 1.1; }
        .alignment-content h2 span { color: var(--sunflower-amber); display: block; font-weight: 400; font-size: 0.7em; margin-top: 8px; }
        .alignment-nav { display: flex; gap: 16px; margin-top: 40px; }
        .alignment-nav button { width: 52px; height: 52px; border-radius: 50%; border: 1px solid rgba(255,255,255,0.2); background: transparent; color: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.3s ease; }
        .alignment-nav button:hover { background: var(--sunflower-amber); border-color: var(--sunflower-amber); transform: scale(1.05); }
        .alignment-card { background: rgba(255,255,255,0.03); backdrop-filter: blur(16px); border: 1px solid rgba(255,255,255,0.1); border-radius: 20px; padding: 48px; color: #fff; transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1); position: relative; overflow: hidden; }
        .alignment-card::before { content: ''; position: absolute; top: 0; left: 0; width: 4px; height: 100%; background: var(--sunflower-amber); }
        .alignment-card h3 { color: var(--sunflower-amber); font-size: 1.75rem; margin-bottom: 20px; font-weight: 700; letter-spacing: -0.01em; }
        .alignment-card p { color: #E2E8F0; font-size: 1.05rem; line-height: 1.7; margin: 0; font-weight: 300; }
        @media (max-width: 992px) { .alignment-container { grid-template-columns: 1fr; text-align: center; gap: 50px; } .alignment-nav { justify-content: center; } .alignment-card { padding: 32px; } }
      `}</style>

      <section className="alignment-viewport">
        <div className="alignment-bg" style={{ backgroundImage: `url(${alignmentData[active].img})` }} />
        
        <div className="alignment-container">
          <div className="alignment-content">
            <h2>Vision<span>Mission & Goal</span></h2>
            <div className="alignment-nav">
              <button onClick={prev} aria-label="Previous"><HiOutlineArrowLeft size={20} /></button>
              <button onClick={next} aria-label="Next"><HiOutlineArrowRight size={20} /></button>
            </div>
          </div>
          
          <div className="alignment-card">
            <h3>{alignmentData[active].title}</h3>
            <p>{alignmentData[active].desc}</p>
          </div>
        </div>
      </section>
    </>
  );
}
